const defaultFormState = {
  user: '',
  number: '',
};

const assignNumberFormState = (state = defaultFormState, action) => {
  switch (action.type) {
    case 'ASSIGN_NUMBER_FIELD_CHANGE':
      return {
        ...state,
        ...{[action.name]: action.value}
      };
    case 'ASSIGN_NUMBER_USER_SUCCESS':
    case 'ASSIGN_NUMBER_USER_CANCEL':
      return defaultFormState;
    case 'ASSIGN_NUMBER_USER_SHOW':
      return {
        ...state,
        ...{number: action.number}
      };
    default:
      return state
  }
};

export default assignNumberFormState;
